import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';

import { GridApi, GridReadyEvent, SelectionChangedEvent } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import * as React from 'react';

import { createStyles, Fab, Paper, Theme, WithStyles, withStyles } from '@material-ui/core';
import Icon from '@material-ui/core/Icon';

import EditRoleDialog from './EditRoleDialog';
import {
  AddRoleRequest, AuthUserDetails, DeleteRoleRequest, Role, ServiceDetails, UserDetails
} from './models/entities';

const styles = (theme: Theme) => createStyles({
    editButtons: {
        float: 'right',
        marginTop: '10px',
        marginRight: '10px'
    }
});

interface Props extends WithStyles<typeof styles> {
    userRoleMap: { [key: string]: UserDetails },
    allUserMap: { [key: string]: AuthUserDetails },
    serviceRoleMap: { [key: string]: ServiceDetails },
    updateRolesHandler: (addRequests: AddRoleRequest[], deleteRequests: DeleteRoleRequest[]) => Promise<boolean>
}

interface State {
    isDialogOpen: boolean,
    selectedUserRoles: UserDetails[]
}

const columns: any[] = [
    {
        headerName: 'Username',
        field: 'username',
        checkboxSelection: true,
        headerCheckboxSelection: true
    },
    {
        headerName: 'ServiceId',
        field: 'serviceId'
    },
    {
        headerName: 'Roles',
        field: 'roles',
        cellRenderer: (params: any) => (params.value as Role[]).map(role => role.name).join(', ')
    }
]

class RoleTable extends React.Component<Props, State> {
    private gridApi: GridApi;

    constructor(props: Props) {
        super(props);
        this.state = {
            isDialogOpen: false,
            selectedUserRoles: []
        };
    }
    public render() {
        const { classes } = this.props;
        return (
            <Paper>
                <div style={{ height: '600px', width: '100%' }} className="ag-theme-material">
                    <AgGridReact
                        enableSorting={true}
                        enableFilter={true}
                        rowSelection="multiple"
                        columnDefs={columns}
                        rowData={Object.keys(this.props.userRoleMap).map(key => this.props.userRoleMap[key])}
                        onGridReady={this.onGridReady}
                        onSelectionChanged={this.onSelectionChanged}
                    />
                </div>
                <div>
                    <Fab color="secondary" aria-label="Delete" className={classes.editButtons} disabled={this.state.selectedUserRoles.length === 0} onClick={this.deleteSelected}>
                        <Icon>delete_icon</Icon>
                    </Fab>
                    <Fab color="default" aria-label="Edit" className={classes.editButtons} disabled={this.getSelectedUser() === undefined} onClick={this.openDialog}>
                        <Icon>edit_icon</Icon>
                    </Fab>
                    <Fab color="primary" aria-label="Add" className={classes.editButtons} onClick={this.addCallBack}>
                        <Icon>add_icon</Icon>
                    </Fab>
                </div>
                <EditRoleDialog userRole={this.getSelectedUser()} isOpen={this.state.isDialogOpen} closeDialog={this.closeDialog} userRoleMap={this.props.userRoleMap} allUserMap={this.props.allUserMap} serviceRoleMap={this.props.serviceRoleMap} updateRolesHandler={this.props.updateRolesHandler} />
            </Paper>);
    }

    private onGridReady = (event: GridReadyEvent) => {
        if (event.api !== null && event.api !== undefined) {
            this.gridApi = event.api;
            event.api.sizeColumnsToFit();
        }
    }

    private onSelectionChanged = (event: SelectionChangedEvent) => {
        const selectedRows = this.gridApi.getSelectedRows();
        this.setState({ ...this.state, selectedUserRoles: selectedRows })
    }

    private closeDialog = () => {
        this.setState({ ...this.state, isDialogOpen: false });
    }
    private openDialog = () => {
        this.setState({ ...this.state, isDialogOpen: true });
    }

    private getSelectedUser = () => {
        if (this.state.selectedUserRoles !== undefined && this.state.selectedUserRoles.length === 1) {
            return this.state.selectedUserRoles[0];
        }
        return undefined;
    }

    private addCallBack = () => {
        this.gridApi.deselectAll();
        this.openDialog();
    }

    private deleteSelected = () => {
        const deleteRequests: DeleteRoleRequest[] = this.state.selectedUserRoles.map((userRoleDetail): DeleteRoleRequest => ({
            userId: userRoleDetail.userId,
            serviceId: userRoleDetail.serviceId,
            roleNames: userRoleDetail.roles.map(role => role.name)
        }));
        this.props.updateRolesHandler([], deleteRequests);
    }
}

export default withStyles(styles)(RoleTable);


// WEBPACK FOOTER //
// ./src/RoleTable.tsx